import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';
import { getSDLHeaderSelector, getHeaderHeight } from '@pes-ui/utils';
import { isBrowser } from './utils';
function observeIntersectionWithHeader(ref, callback) {
  if (!ref) {
    return;
  }
  let headerHeight = getHeaderHeight();
  let viewportHeight = window.innerHeight;
  if (!headerHeight) {
    return;
  }
  const setupIntersectionObserver = () => {
    const tabBarHeight = 48;
    const offset = 5;
    const topMargin = (headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0) + tabBarHeight + offset;
    const bottomMargin = viewportHeight - topMargin - offset * 3;
    const observer = new IntersectionObserver(callback, {
      rootMargin: `-${topMargin}px 0px -${bottomMargin}px 0px`,
    });
    observer.observe(ref);
    return observer;
  };
  let observer = setupIntersectionObserver();
  const ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;
  let headerRO;
  if (isBrowser()) {
    headerRO = new ResizeObserver(([entry]) => {
      const { height } = entry.contentRect;
      if (height !== headerHeight) {
        headerHeight = height;
        observer.disconnect();
        observer = setupIntersectionObserver();
      }
    });
    window.addEventListener('resize', () => {
      if (window.innerHeight !== viewportHeight) {
        viewportHeight = window.innerHeight;
        observer.disconnect();
        observer = setupIntersectionObserver();
      }
    });
  }
  const sdlHeader = document.querySelector(getSDLHeaderSelector());
  if (sdlHeader && headerRO) {
    headerRO.observe(sdlHeader);
  }
}
export function initStickyBarStore() {
  window.__STICKYBARSTORE = {
    items: [],
    active: {},
    setItem({ name, titles }) {
      const event = new Event('tabInit');
      this.items.push({ name, titles });
      window.dispatchEvent(event);
    },
  };
}
function initSDLHeaderResizeObserver(callback) {
  const headerEl = document.querySelector(getSDLHeaderSelector());
  if (headerEl) {
    const ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;
    const sdlHeaderResizeObserver = new ResizeObserver(callback);
    sdlHeaderResizeObserver.observe(headerEl);
    return sdlHeaderResizeObserver;
  }
}
function setStickyBarTab(tabName, titles) {
  var _a;
  if (!tabName)
    return;
  (_a = window.__STICKYBARSTORE) === null || _a === void 0 ? void 0 : _a.setItem({
    name: tabName,
    titles,
  });
}
function deleteStickyBarTab(tabName) {
  if (!tabName)
    return;
  const store = window.__STICKYBARSTORE;
  if (!store)
    return;
  store.items = store.items.filter((item) => item.name !== tabName);
  if (store.active.type === tabName) {
    store.active = {};
  }
  const event = new Event('tabInit');
  window.dispatchEvent(event);
}
function setTabActive(tab) {
  window.__STICKYBARSTORE.active = tab;
}
export { observeIntersectionWithHeader, initSDLHeaderResizeObserver, setStickyBarTab, deleteStickyBarTab, setTabActive, };
